import React, {Component} from 'react';
import axios from '../../axios';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Loader} from 'semantic-ui-react'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../stylesheets/landingPageStyles.css'


class ReviewsComponent extends Component {
    constructor(props) {
        super(props);
        this.state  = {
            counter:1,
            feedbacks:null,
            hasMoreFeedback:true
        }
    }
    
    componentDidMount() {
        this.fetchData()
    }

    getRatings = (rating) =>{
        let ratingsHtml = []
        let cnt =null
        for(cnt=0;cnt<rating;cnt++){
            ratingsHtml.push(<FontAwesomeIcon icon = {faStar} className="starIcon" key={cnt}/>)
        }
        for(cnt=rating;cnt<5;cnt++){
            ratingsHtml.push(<FontAwesomeIcon icon = {faStar} key={cnt}/>)
        }
        return ratingsHtml
    }

    
    fetchData = ()=> {
         axios.get(`/courses/${this.props.courseSlug}/feedbacks/?page=${this.state.counter}`)
        .then(res => {
            if (res.data){
                if(res.data.results && res.data.results.length >= 0) {
                    if (!this.state.feedbacks)
                        this.setState(prevState =>{
                            return {
                                feedbacks : [...res.data.results],
                            }
                        })
                    else
                        this.setState(prevState =>{
                            return {
                                feedbacks : [...prevState.feedbacks, ...res.data.results],
                            }
                        })
                }

                this.setState(prevState =>{
                    return {
                        hasMoreFeedback:res.data.next,
                        counter: prevState.counter + 1
                    }
                })
            
            } 
           
        })
    }
    
    render() {
        if (!this.state.feedbacks)
        return (<div style={{height:"60vh"}}><Loader active/></div>)
        return (
            <section >
                    <InfiniteScroll
                        dataLength={this.state.feedbacks.length}
                        next={
                            this.fetchData
                        }
                        height={'60vh'} 
                        hasMore={this.state.hasMoreFeedback}
                        loader = {<div className="infiniteScrollLoader">
                            <Loader active inline/>
                        </div>}
                        endMessage={<div />}
                    >
                        {
                            this.state.feedbacks.map((feedback, index) => {
                                return (
                                    <div className="feedbacks" key = {index}>
                                        <div className="feedback">
                                           
                                             <div className="imgCnt">
                                                <img alt="" className = "rounded-circle img-fluid img" src = {feedback.img_url}></img>        
                                                <div className="sofia-pro detailsCnt feedCnt">
                                                <span className = "feedHandle">{feedback.handle}</span>
                                                        <span>
                                                            <span className ="divider"></span>
                                                            <FontAwesomeIcon icon = {faStar} className="starIconFeed"/>
                                                            <span>
                                                            {feedback.rating}
                                                            </span>
                                                        </span> 
                                                </div>
                                                 {/* <div className="rating">
                                                        <div className="sofia-pro handle" >{feedback.handle}</div>
                                                        <div className="starCnt">
                                                        {
                                                            this.getRatings(feedback.rating)
                                                        }
                                                        </div>
                                                </div> */}
                                            </div>
                                            <div className="sofia-pro comment">
                                                {feedback.modified_data}
                                            </div>
                                        </div>
                                       
                                    </div> 
                                )                   
                            })
                        }
                        
                    </InfiniteScroll>
            </section>
        );
    }
}

export default ReviewsComponent;